import { useState } from 'react'
import { useAuth } from '../stores/auth'
import { ArrowRight, CheckCircle } from 'lucide-react'

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const { login } = useAuth()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email.trim()) return

    setLoading(true)
    setError('')

    const result = await login(email.trim())

    if (result.success) {
      setSent(true)
    } else {
      setError(result.error || 'Anmeldefehler')
    }
    setLoading(false)
  }

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-extrabold tracking-[0.25em]" style={{ background: 'linear-gradient(135deg, #c8c8d0, #8a8a96, #c8c8d0)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>VNVLD</h1>
          <p className="text-[#b0aeb8] mt-1">Club Management Dashboard</p>
        </div>

        {sent ? (
          /* Success state */
          <div className="bg-[#131316] border border-white/5 rounded-2xl p-8 text-center">
            <CheckCircle className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-white mb-2">E-Mail gesendet!</h2>
            <p className="text-[#b0aeb8] mb-4">
              Wir haben einen Login-Link an <span className="text-white">{email}</span> geschickt.
              Klicke auf den Link in der E-Mail, um dich anzumelden.
            </p>
            <p className="text-sm text-[#707078]">
              Kein Link erhalten? Prüfe deinen Spam-Ordner oder{' '}
              <button onClick={() => setSent(false)} className="text-[#c8c8d0] hover:underline">
                versuche es erneut
              </button>.
            </p>
          </div>
        ) : (
          /* Login form */
          <form onSubmit={handleSubmit} className="bg-[#131316] border border-white/5 rounded-2xl p-8">
            <h2 className="text-xl font-semibold text-white mb-6">Anmelden</h2>

            <div className="mb-4">
              <label htmlFor="email" className="block text-sm text-[#b0aeb8] mb-2">
                E-Mail-Adresse
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="deine@email.de"
                className="w-full px-4 py-3 bg-white/5 border border-white/5 rounded-xl text-white placeholder-[#707078] focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-transparent transition-all"
                autoFocus
                required
              />
            </div>

            {error && (
              <p className="text-red-400 text-sm mb-4">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading || !email.trim()}
              className="w-full py-3 bg-white/10 hover:bg-white/15 border border-white/10 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-xl flex items-center justify-center gap-2 transition-colors"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <>
                  Magic Link senden
                  <ArrowRight className="w-4 h-4" />
                </>
              )}
            </button>

            <p className="text-xs text-[#707078] text-center mt-4">
              Kein Passwort nötig — wir schicken dir einen sicheren Login-Link per E-Mail.
            </p>
          </form>
        )}

        {/* Footer */}
        <p className="text-center text-xs text-[#707078]/50 mt-8">
          Powered by VNVLD — Dein Club, dein System.
        </p>
      </div>
    </div>
  )
}
